<script>
  // Перенос SegToggle из lib/ui.tsx — сегментный тумблер (напр. RU | EN).
  export let options = [];
  export let value = '';
  export let onChange = () => {};
</script>

<div class="ui-seg">
  {#each options as o (o.id)}
    <div class={'opt' + (o.id === value ? ' on' : '')} on:click={() => onChange(o.id)}>{o.label}</div>
  {/each}
</div>
